export default __webpack_public_path__ + "static/media/loading.554c5841.gif";